import { Modal, Alert, Button } from '../../components/ui';
import { formatFechaLarga, formatHora } from '../../utils/fechas';
import { nombreSede } from './MisTurnosUtils';

export default function TarjetaCancelar({ turno, onClose, onConfirm, error, loading }) {
  return (
    <Modal
      open={!!turno}
      onClose={onClose}
      title="Cancelar este turno"
      actions={
        <>
          <Button variant="secondary" onClick={onClose} disabled={loading}>No</Button>
          <Button variant="danger" data-testid="confirmar-cancelacion" onClick={onConfirm} disabled={loading}>
            {loading ? 'Cancelando...' : 'Sí, cancelar'}
          </Button>
        </>
      }
    >
      {turno && (
        <>
          <p>{formatFechaLarga(turno.fechaYHora)} - {formatHora(turno.fechaYHora)}</p>
          <p>{turno.medico || 'Médico no disponible'}</p>
          <p>{nombreSede(turno.sede)}</p>
          {error && <Alert tone="danger" title="Error">{error}</Alert>}
        </>
      )}
    </Modal>
  );
}